<mat-form-field appearance="outline" class="full-width">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    [matDatepicker]="picker"
    [value]="value"
    [min]="min"
    [max]="max"
    (dateChange)="onSelect($event.value)"
    (blur)="onTouched()"
    [disabled]="disabled"
  />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
